module.exports = {
    urlApi: 'https://jacochef.ru/api/site/test_app.php',
    //urlApi: 'http://151.248.124.144/test_app.php',  
}